class Downloads {
  constructor(params) {
    this.dateFrom = params.dateFrom;
    this.dateTo = params.dateTo;
  }
}

export { Downloads };
